// extracted by mini-css-extract-plugin
export default {"capsule_container":"style_capsule_container__G1hZp","capsule_button":"style_capsule_button__XdstU","capsule_active":"style_capsule_active__rqyVe"};